import { useEffect, useRef, useState } from 'react';
import { useDebounce } from 'react-use';
import Search from './Search';
import { useSearchParams } from 'hooks';

const LocationAwareSearch = ({
  placeholder,
  debounceTime = 500,
  name,
  options,
  resetPage,
  defaultValue,
  ...props
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [value, setValue] = useState(searchParams[name] || defaultValue || '');
  const mounted = useRef(false);

  useEffect(() => {
    if (!mounted.current) {
      mounted.current = true;
      return;
    }
    setValue(searchParams[name] || '');
  }, [searchParams[name]]);

  useDebounce(
    () => {
      // Changing the search always jumps back to the first page.
      setSearchParams({ ...searchParams, [name]: value, page: undefined });
      if (typeof resetPage === 'function') resetPage();
    },
    debounceTime,
    [value],
  );

  return (
    <Search
      value={value}
      placeholder={placeholder}
      onChange={(value) => setValue(value)}
      onClear={() => setValue('')}
      {...props}
    />
  );
};

export default LocationAwareSearch;
